import { useState } from "react";
import * as yup from 'yup';

const useHandleForm = (data, submitCallback, invalidDataCallback) => {

  const createInitialData = () => {

    const getInitialFieldData = (fieldName) => {
      if (fieldName === "active") return data?.active;
      return data?.[fieldName] || "";
    }

    const fieldNames = [
      "active",
      "name",
      "description",
      "sqlFilter",
    ];

    return fieldNames.reduce((initialData, fieldName) => {
      return ({
        ...initialData,
        [fieldName]: getInitialFieldData(fieldName)
      })
    }, {});
  }

  const [formData, setFormData] = useState(() => createInitialData());

  const dataIsValid = async () => {
    const schema = yup.object().shape({
      name: yup.string().required(),
      description: yup.string().required(),
      sqlFilter: yup.string(),
    });

    return await schema.validate(formData, { abortEarly: false })
      .then((castData) => castData)
      .catch(err => {
        if (err instanceof yup.ValidationError) {
          err.inner.forEach(error => {
            console.log(error.message);
          });
          return false;
        }
      });
  }


  const submit = async () => {
    if (await dataIsValid()) {
      const dataToSend = { ...formData };
      submitCallback(dataToSend);
      return true;
    } else {
      invalidDataCallback();
      return false;
    }
  }

  const setFormValue = (value, fieldName) => {
    setFormData({
      ...formData,
      [fieldName]: value,
    });
  }

  return {
    formData,
    setFormValue,
    submit,
  };
}

export default useHandleForm;